import StyledLoading from '@app/react-common/Loading';
import { OrgDoc } from '@bb/domain/dist/schemas';
import React from 'react';
import type { JsonObject } from '@/app-package';
import BrokerageTile from '../BrokerageTile';
import { StyledBrokerageTileContainer, StyledHR } from './StyledComponents';

type Org = JsonObject<OrgDoc>;

interface BrokeragesListItemsProps {
  isLoaded: boolean;
  alphKeys: string[];
  alphMap: { [key: string]: Org[] };
}

const BrokeragesListItems: React.FC<BrokeragesListItemsProps> = ({
  isLoaded,
  alphKeys,
  alphMap,
}) => (
  <>
    {!isLoaded ? (
      <StyledLoading className="normalheader transition animated fadeIn row col-md-2 col-md-offset-5 spin" />
    ) : (
      alphKeys.map(
        (key: string, i: number) =>
          alphMap[key].length > 0 && (
            <div key={i}>
              <h4>
                {key}
                <StyledHR />
              </h4>
              <StyledBrokerageTileContainer>
                {alphMap[key].map((org, j: number) => (
                  <BrokerageTile key={j} org={org} />
                ))}
              </StyledBrokerageTileContainer>
            </div>
          ),
      )
    )}
  </>
);

export default BrokeragesListItems;
